module.exports = __webpack_public_path__ + "img/MGH-Yokohama-2.38bc4d3a.jpg";